/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
import carousel from 'vue-owl-carousel';
import createdModels from './created-models-list/index.vue';
import publicModels from './public-models/index.vue';
import sharedModels from './shared-models-list/index.vue';
import recentlyUsedModels from './recently-used-models/index.vue';
import usedHistoryModelsList from './used-models-history-list/index.vue';
export default {
  name: 'ai-dashboard',
  components: {
    carousel,
    'created-models' : createdModels,
    'public-models' : publicModels,
    'recently-used-Models' : recentlyUsedModels,
    'shared-models-list' : sharedModels,
    'used-history-models-list' : usedHistoryModelsList
  },
  props: [],
  data () {
    return {
      countryList:[],
      userFilterInfoPopupState:false,
      userFilterInfoPopupStateClass:false,
      userFilterInfoData:null
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    userFiltersInfoPopupMethod(data){
      this.userFilterInfoData = data
      $(window).scrollTop(0);
      this.userFilterInfoPopupState = true
      document.body.classList.add('body_right_scroll_remove')
      setTimeout(() => {
        this.userFilterInfoPopupStateClass = true
      }, 10);
    },
    clickedOutside() {
      this.userFilterInfoPopupStateClass = false
      setTimeout(() => {
        this.userFilterInfoPopupState = false
        document.body.classList.remove('body_right_scroll_remove')
        this.userFilterInfoData = ''
      }, 600);
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    $("body").removeClass("body_right_scroll_remove");
    next();
  },
}